// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZPom8ImOFQuftFg13uue{cursor:pointer;width:calc(100% - 8px);height:32px;color:var(--content-primary-primary);background:0 0;border:none;align-items:center;gap:8px;margin-left:4px;margin-right:4px;padding-left:12px;padding-right:12px;display:flex}.ZPom8ImOFQuftFg13uue:hover{background:var(--background-neutral-subtle);border-radius:6px}.ZPom8ImOFQuftFg13uue .AezfLjKFUXUlOeKHVWxI{text-align:left;flex-grow:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `ZPom8ImOFQuftFg13uue`,
	"title": `AezfLjKFUXUlOeKHVWxI`
};
export default ___CSS_LOADER_EXPORT___;
